// extracted by mini-css-extract-plugin
export default {"container":"ProjectsContainer_container__WcrMu","toBottom":"ProjectsContainer_toBottom__d4c9I"};